import React, { useState,useEffect,useRef } from "react";
import './classes/EditAgentProfile.css';
import Editor from 'react-simple-wysiwyg';
import { configData } from "../config";
import { useNavigate,useLocation  } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Loading from './Loading';
import Link from '@mui/material/Link';
import EditScoutProfile from "./EditScoutProfile";

const ViewScoutProfile = ({uid,userLoggedInRoles, userDetails}) => {

    const [toggles, setToggles] = useState({
        ScoutMainDetails: true,
        scoutMoreDetails: true,
        ScoutJobTitle: true,
        ScoutBio: true,
        educationToggle: true,
        contactInfo: true,
        socialMediaToggle: true,
        ScoutContractToggle: true,
    });

    const handleToggle = (key) => {
        setToggles((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const navigate = useNavigate();
    const app_url = configData.APP_URL;

 
    const [scoutuploadFiles, setScoutUploadedFiles] = useState([]);
    const[userScoutAssets,setUserScoutAssets] = useState([]);
    const[userSocailMediaAssets,setUserSocialMediaAssets] = useState([]);
    const[userCommonAssets,setUserCommonAssets] = useState({});
    const [sportList, setSportList] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const loggedin_uid = localStorage.getItem('drupal_uid');

    const[userViewScoutAssets,setUserViewScoutAssets] = useState({});

const sections = [
  {
    key: "field_scout_title",
    keyToggle: "ScoutJobTitle",
    title: "Title",
    emptyText: "No title set.",
    customClass2: ""
  },
  {
    key: "field_scout_biography",
    keyToggle: "ScoutBio",
    title: "Scout Biography",
    emptyText: "No biography content.",
    customClass: "" //  special styling
  },
  {
    key: "field_education",
    keyToggle: "educationToggle",
    title: "Education",
    emptyText: "No education info.",
    customClass: "" //  special styling
  },
  {
    key: "field_how_to_contact_client",
    keyToggle: "contactInfo",
    title: "How to Contact",
    emptyText: "No contact info.",
    customClass: "" //  special styling
  }
];

const rightSectionFields = [
    { label: "Scout ID#", key: "field_scout_id", style: { fontSize: "16px" } },
    // { label: "Scout Rank", key: "field_scout_rank" },
    { label: "Slug", key: "field_scout_slug" },
    // { label: "Expiration", key: "field_expiration_date" },
    // { label: "Region", key: "field_scout_region" },
    { label: "Scout Sort Order", key: "field_scout_sort_order" },
    { label: "Show on Frontend", key: "field_show_on_frontend_scout" },
    // { label: "Scout Featured", key: "field_scout_featured" },
];

    const [activeView, setActiveView] = useState("view");

    const showView = () => {
        const newView = activeView === "view" ? "edit_scout" : "scout";
        setActiveView(newView);

        navigate(`/user/${uid}/${newView}`);
    };

  const location = useLocation();

    useEffect(() => {
    if (location.pathname.includes("/edit_scout")) {
        setActiveView("edit");
    } else {
        setActiveView("view");
    }
    }, [location.pathname]);

const successScoutEditMessage = location.state?.result; 
  
const [successEditMessage, setSuccessEditMessage] = useState('');

useEffect(() => {
    if (successScoutEditMessage) {
    setSuccessEditMessage(successScoutEditMessage);
    getscoutdetails();
    window.history.replaceState({}, '');
    }
}, [successEditMessage, location.state]);

const scoutSportField = userScoutAssets?.find(
    (item) => item.key === "field_scout_sport"
);

const scoutSportlist = scoutSportField?.full_value
    ? scoutSportField.full_value.split(",")
    : [];

    let parsedSportList = [];

    try {
    parsedSportList = Array.isArray(sportList)
        ? sportList
        : JSON.parse(sportList);
    } catch {
    parsedSportList = [];
    }

    const sportMap = Object.fromEntries(
    parsedSportList.map(s => [s.key, s.value])
    );

const transformData = (dataArray) => {
    return dataArray.reduce((acc, item) => {
        if (item.date || item.time) {
        acc[item.key] = {
            date: item.date,
            time: item.time
        };
        } else {
        acc[item.key] = item.value ?? item.full_value ?? null;
        }
        return acc;
    }, {});
};

const backEndData = transformData(userScoutAssets);

const mergedData = {
    ...backEndData,
    ...userCommonAssets,
    ...userViewScoutAssets
};

    async function getscoutdetails() { 
    
        if(uid!='') {
            try {
                setIsLoading(true);
            const response = await fetch(
            app_url+'viewprofile/getscoutdetails?uid='+uid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
            )
            const responsedata = await response.json();
            if(responsedata.data.result === "Success") {
            //uid = responsedata.data.user.drupal_uid;
                setUserScoutAssets(responsedata.data.user_scout_assets || []);
                setUserSocialMediaAssets(responsedata.data.user_social_media_assets || []);
                setUserCommonAssets(responsedata.data.user_common_assets || {});
                setUserViewScoutAssets(responsedata.data.user_view_scout_assets || {});
            }
            }  catch (error) {
            console.error('Error fetching data:', error);
            } finally {
            setIsLoading(false);
            }
        }
    }

    async function getsportslist() {
        try {
            const response = await fetch(
                app_url+'smwwscout/scoutsports',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSportList(responsedata.data);
            } 
        } catch (err) {
            
        }
            
    }

    useEffect(() => {
        if (!Array.isArray(userScoutAssets)) return;

        const contractItem = userScoutAssets.find(
            item => item.key === "field_scout_contract"
        );

        setScoutUploadedFiles(contractItem?.full_value || []);
    }, [userScoutAssets]);

    useEffect(() => {
    const promises = [
        getscoutdetails(),
        getsportslist()
    ];

    Promise.all(promises)
        .then(() => {
        setIsLoading(false);
        })
        .catch(error => {
        console.error(error);
        // Handle error
        });
    }, []);

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png'; // fallback icon
        }
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (        
                <> 
                {activeView === "view" ? (
                <div>
                    <div className='viewtab-top-section'>

                        {successEditMessage && (
                            <div className="set-message-done" style={{marginBottom: "5px"}}>
                                <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span>&nbsp;
                                {/* {successEditMessage} */}
                                <span
                                    dangerouslySetInnerHTML={{ __html: successEditMessage }}
                                />
                            </div>
                        )}
                        <div>
                            <div className="edit-agent-prof-editbtn">
                                <button class="main-app-action-btn edit-fields-btn" onClick={showView}>✎ Edit</button>
                            </div>
                            <div 
                                className={`view-user-profile-section-header agent-section-header ${toggles["ScoutMainDetails"] ? "open" : ""}`}
                                style={{border: "0px", outline: "1px solid #bbb"}}
                            >
                                <div class="app-aspect-content" onClick={() => handleToggle("ScoutMainDetails")}>
                                    <div class="aspect-info">
                                        <span class="view-user-profile-section-heading"><strong>Scout Profile</strong></span>
                                    </div>
                                </div>
                                {toggles.ScoutMainDetails && (
                                    <div class="view-user-profile-section-body-container">
                                        <div class="view-user-profile-section-container user-profile-summary-table user-profile-details user-contact-info">

                                            <div className="edit-agent-prof-details"
                                                style={(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN))
                                                    ? {} : { justifyContent: "flex-start" }}
                                            >
                                                <div style={{flexShrink: "0"}}>
                                                    <div class="edit-agent-image">
                                                        {mergedData?.["field_scout_photo"] ? (
                                                            <img
                                                                src={mergedData["field_scout_photo"]}
                                                                width="100px"
                                                                height="100px"
                                                                alt="user"
                                                            />
                                                        ) : (
                                                            <div className="edit-agent-img-placeholder">
                                                                No Photo<br />Uploaded
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="agent-img-desc">100–1000px · png/jpg/gif</div>
                                                </div>
                                        
                                                <div class="agent-name-loc" style={{marginBottom:'2%', minWidth: "200px", maxWidth: "495px"}}>
                                                    <div class="user-name" style={{color:"#333333"}} >{userDetails.first_name} {userDetails.last_name}</div>
                                                    <div class="user-loc" style={{marginBottom:"15px",fontSize:"13px",color:"#666666"}}>{userDetails.city && userDetails.city+', '} 
                                                    {userDetails.state && userDetails.state+', '} {userDetails.country && userDetails.country}</div>
                                                    <div class="user-loc" style={{marginBottom:"5px",fontSize:"12px",fontWeight:"700",color:"#666666"}}>Scout Sports</div>

                                                        <span className='profile-applied-course-tag-row' style={{padding: "0px", marginBottom: "15px"}}>
                                                    {scoutSportlist.length > 0 ? (
                                                        scoutSportlist.map((item, index) => (
                                                        <span key={index} className="profile-applied-course-tags">
                                                            {sportMap[item]}
                                                        </span>
                                                        ))
                                                    ) : (
                                                        <span
                                                        className="profile-applied-course-tags"
                                                        style={{ color: "#999", fontStyle: "italic" }}
                                                        >
                                                        None selected
                                                        </span>
                                                    )}</span>

                                                </div>


                                            {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                                                <div className="agent-profile-right">
                                                    {rightSectionFields.map((item) => {
                                                        let value = mergedData?.[item.key];

                                                        if (item.key === "field_show_on_frontend_scout") {
                                                            return (
                                                                <div className="agent-profile-right-content" key={item.key}>
                                                                    <div className="agent-profile-right-content-label">
                                                                        {item.label}
                                                                    </div>
                                                                    <div className="agent-profile-right-content-value">
                                                                        {Number(value) === 1 ? "Yes" : "No"}
                                                                    </div>
                                                                </div>
                                                            );
                                                        }

                                                        return (
                                                            <div className="agent-profile-right-content" key={item.key}>
                                                                <div className="agent-profile-right-content-label">
                                                                    {item.label}
                                                                </div>
                                                                <div className="agent-profile-right-content-value">
                                                                    {value || "-"}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                    {userViewScoutAssets.field_expiration_date && 
                                                    <div className="agent-profile-right-content">
                                                        <div className="agent-profile-right-content-label">Expiration</div>
                                                        <div className="agent-profile-right-content-value">{userViewScoutAssets.field_expiration_date}</div>
                                                    </div>}
                                                </div>}

                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div style={{clear: "both"}}></div>
                        </div>
                    </div>
                    {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                    <div className={`view-user-profile-section-header ${toggles["scoutMoreDetails"] ? "open" : ""}`}>
                        
                        <div className="app-aspect-content" onClick={() => handleToggle("scoutMoreDetails")}>
                            <div className="aspect-info">
                                <span className="view-user-profile-section-heading">
                                    <strong>Scout Details</strong>
                                </span>
                            </div>
                        </div>

                        {toggles.scoutMoreDetails && (
                            <div className="view-user-profile-section-body-container">
                                <div className="profile_summary_sentiment-wrapper view-user-profile-section-container">
                                    <div className="opinion-header profile_summary view-user-profile-section-content">

                                        <table className="user-profile-summary-table">
                                            <tbody>
                                                {[
                                                    ["field_scout_rank", "Scout Rank"],
                                                    ["field_scout_region", "Scout Region"],
                                                ].map(([key, label]) => {
                                                    let value = mergedData?.[key];

                                                    // if (!value) return null;

                                                    return (
                                                        <tr key={key}>
                                                            <td className="user-profile-summary-row" valign="top">
                                                                <span className="user-profile-label">
                                                                    {label}:&nbsp;
                                                                </span>
                                                            </td>

                                                            <td className="user-profile-summary-row" valign="top">
                                                                <span className="user-profile-value">
                                                                    {value || "-"}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}

                                                {/* Status & Visibility - Showing all fields with Yes/No status */}
                                                {userScoutAssets
                                                    .filter(item => 
                                                        ['field_scout_featured'].includes(item.key)
                                                    )
                                                    .map((item) => (
                                                        <tr key={item.key}>
                                                            <td className="user-profile-summary-row">
                                                                <span className="user-profile-label">{item.label}:&nbsp;</span>
                                                            </td>
                                                            <td className="user-profile-summary-row">
                                                                <span className="user-profile-value">
                                                                    {/* Ternary: If value is 1 show Yes, otherwise show No */}
                                                                    {Number(item.value) === 1 ? "Yes" : "No"}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }

                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        )}
                    </div>}

                    {sections.map((section) => {
                        //   const content = backEndData?.[section.key];
                        const content = mergedData?.[section.key];

                        return (
                            <div
                            key={section.keyToggle}
                            className={`view-user-profile-section-header ${
                                toggles[section.keyToggle] ? "open" : ""
                            }`}
                            >
                            <div
                                className="app-aspect-content"
                                onClick={() => handleToggle(section.keyToggle)}
                            >
                                <div className="aspect-info">
                                <span className="view-user-profile-section-heading">
                                    <strong>{section.title}</strong>
                                </span>
                                </div>
                            </div>

                            {toggles[section.keyToggle] && (
                                <div className="view-user-profile-section-body-container">
                                <div
                                    className={`opinion-header profile_summary view-agent-profile-section-content ${
                                    section.customClass || ""
                                    }`}
                                >
                                    {content ? (
                                    <div
                                        // className="agent-richtext-placeholder"
                                        className={`agent-richtext-placeholder ${section.customClass2 || ""}`}
                                        dangerouslySetInnerHTML={{ __html: content }}
                                    />
                                    ) : (
                                    <div className="agent-richtext-placeholder empty">
                                        {section.emptyText}
                                    </div>
                                    )}
                                </div>
                                </div>
                            )}
                            </div>
                        );
                    })}

                    <div className={`view-user-profile-section-header ${toggles["socialMediaToggle"] ? "open" : ""}`}>
                        <div class="app-aspect-content" onClick={() => handleToggle("socialMediaToggle")}>
                            <div class="aspect-info">
                                <span class="view-user-profile-section-heading"><strong>Social Media</strong></span>
                            </div>
                        </div>
                        {toggles.socialMediaToggle && (
                        <div className="view-user-profile-section-body-container">
                            {userSocailMediaAssets && Object.keys(userSocailMediaAssets).some(key => userSocailMediaAssets[key]) ? (
                            <div className="profile_summary_sentiment-wrapper view-user-profile-section-container">
                                <div className="opinion-header profile_summary view-user-profile-section-content">
                                <table className="user-profile-summary-table">
                                    <tbody>
                                    {[
                                        ['field_instagram_url', 'Instagram URL'],
                                        ['field_instagram_handle', 'Instagram Handle'],
                                        ['field_facebook_url', 'Facebook URL'],
                                        ['field_facebook_handle', 'Facebook Handle'],
                                        ['field_twitter_url', 'Twitter URL'],
                                        ['field_user_youtube_url', 'YouTube URL'],
                                        ['field_linkedin_url', 'LinkedIn URL'],
                                        ['field_linkedin_handle', 'LinkedIn Handle'],
                                    ].map(([key, label]) => {
                                        const value = userSocailMediaAssets[key];
                                        // Skip empty values
                                        if (!value) return null;
                                        return (
                                        <tr key={key}>
                                            <td className="user-profile-summary-row" valign="top">
                                            <span className="user-profile-label">
                                                {label}:&nbsp;
                                            </span>
                                            </td>
                                            <td className="user-profile-summary-row" valign="top">
                                            <span className="user-profile-value">
                                                {value || "-"}
                                            </span>
                                            </td>
                                        </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                                </div>
                            </div>
                            ) : (
                            <div className="opinion-header profile_summary view-agent-profile-section-content">
                                <div className="agent-richtext-placeholder empty">
                                No social media content.
                                </div>
                            </div>
                            )}
                        </div>
                        )}
                    </div>

            {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                <div className={`view-user-profile-section-header ${toggles["ScoutContractToggle"] ? "open" : ""}`}>
                    <div class="app-aspect-content" onClick={() => handleToggle("ScoutContractToggle")}>
                        <div class="aspect-info">
                            <span class="view-user-profile-section-heading"><strong>Scout Contract</strong></span>
                        </div>
                    </div>
                    {toggles.ScoutContractToggle && (
                        <div class="view-user-profile-section-body-container">
                            <div class="opinion-header profile_summary view-agent-profile-section-content">
                                {Array.isArray(scoutuploadFiles) &&
                                scoutuploadFiles.length > 0 ? (
                                <div className="agent-richtext-placeholder" style={{ border: "0" }}>
                                    <ul>
                                    {scoutuploadFiles.map((file, index) => (
                                        <li key={index}>
                                            <img
                                                src={getFileIcon(file.name)}
                                                alt="file icon"
                                            />&nbsp;
                                            <a href={file.url} target="_blank" rel="noopener noreferrer">
                                                {file.name}
                                            </a>
                                        </li>
                                    ))}
                                    </ul>
                                </div>
                                ) : (
                                <div
                                    className="agent-richtext-placeholder empty"
                                    style={{ border: "0" }}
                                >
                                    No contract files uploaded. Allowed: txt, png, jpg, jpeg, pdf, docx (max 128 MB)
                                </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>}

            </div>
        ) : (<>
            <EditScoutProfile uid={uid} userLoggedInRoles={userLoggedInRoles} userScoutAssets={userScoutAssets} />
        </>)}

        </>
        )}
        </>
    );
};

export default ViewScoutProfile;